/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListFinancialTransactionsQueryResponse, ListFinancialTransactionsPathParams, ListFinancialTransactionsQueryParams, ListFinancialTransactions400, ListFinancialTransactions401, ListFinancialTransactions403, ListFinancialTransactions404, ListFinancialTransactions409, ListFinancialTransactions500 } from "../../types/financialHubController/ListFinancialTransactions.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListFinancialTransactionsUrl(organizationId: ListFinancialTransactionsPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/financial/transactions/` as const }
  return res
}

/**
 * @summary List ledger transactions
 * {@link /api/organizations/:organizationId/financial/transactions/}
 */
export async function listFinancialTransactions(organizationId: ListFinancialTransactionsPathParams["organizationId"], params?: ListFinancialTransactionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListFinancialTransactionsQueryResponse, ResponseErrorConfig<ListFinancialTransactions400 | ListFinancialTransactions401 | ListFinancialTransactions403 | ListFinancialTransactions404 | ListFinancialTransactions409 | ListFinancialTransactions500>, unknown>({ method : "GET", url : getListFinancialTransactionsUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}